import { ReactNode } from 'react'
import { Stack, Text } from '@fluentui/react'

type PerformancePanelProps = {
  title: string
  isEmpty: boolean
  emptyMessage: string
  headingLevel?: 'h2' | 'h3'
  children?: ReactNode
  minWidth?: number
}

const PerformancePanel = ({
  title,
  isEmpty,
  emptyMessage,
  headingLevel = 'h2',
  children,
  minWidth = 300,
}: PerformancePanelProps) => (
  <Stack
    styles={{
      root: {
        padding: '24px',
        backgroundColor: '#fff',
        borderRadius: 8,
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        flex: 1,
        minWidth,
      },
    }}
    tokens={{ childrenGap: 12 }}
  >
    <Text as={headingLevel} variant="mediumPlus" styles={{ root: { margin: 0, fontWeight: 600, color: '#605e5c' } }}>
      {title}
    </Text>
    {isEmpty ? (
      <Text styles={{ root: { color: '#a19f9d', textAlign: 'center', padding: 40 } }}>{emptyMessage}</Text>
    ) : (
      children
    )}
  </Stack>
)

export default PerformancePanel
